import MarketingManager from './MarketingManager'

export default MarketingManager
